module.exports = __webpack_public_path__ + "static/media/background-euro-notes-light.5cc9495d.jpg";